module.exports = __webpack_public_path__ + "static/media/tag.c0896898.svg";